import React, { useState, useEffect } from 'react'
import {Row,Col,Form,Table ,Button} from 'react-bootstrap'
import Card from '../../../components/Card'
import { toast } from 'react-toastify';
import { API_COMPANY_PROFILE, API_PARENT_COMPANY_LICENCE,API_MANAGE_LOCATIONS_LIST,API_MANAGE_GROUP_LISTING, API_CALL_STRATEGIES_MASTER_LIST  } from '../../../service/url';
import { postApiCall, getApiCall } from '../../../service/httpCall';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES , USER_ROLES} from '../../../utilities/constant';
import RenderUserCompanyFields from "../../../components/partials/dashboard/users/company";
import { validatePhone } from "../../../utilities/helpers";
import AsyncStorage from '@react-native-async-storage/async-storage';
import Select from 'react-select';

const CompanyUpdate = () => {

   const { id } = useParams();
   const navigate = useNavigate();

   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [companyName, setCompanyName] = useState("");
   const [companyPhone, setCompanyPhone] = useState("");
   const [companyAddress, setCompanyAddress] = useState("");
   const [companyPincode, setCompanyPincode] = useState("");
   const [companyLicence, setCompanyLicence] = useState("");
   const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
   const [agent, setAgent] = useState(0);
   const [liveAgent, setLiveAgent] = useState(0);
   const [channel, setChannel] = useState(0);
   const [asReseller, setAsReseller] = useState(0);
   const [asCompany, setAsCompany] = useState(0);
   const [availableLicence, setAvailableLicence] = useState({});
   const [errors, setErrors] = useState({});
   const [totalLicence, setTotalLicence] = useState({});
   const [usedLicence, setUsedLicence] = useState({});
   const [loginUserRole, setLoginUserRole] = useState(null);
   const [parentLicence, setParentLicence] = useState(null);
   const [initialLicence, setInitialLicence] = useState({});
   const [selectedCallStrategy, setSelectedCallStrategy] = useState([]);
   const [selectedLocation, setSelectedLocation] = useState([]);
   const [selectedGroup, setSelectedGroup] = useState([]);
   const [locations, setLocations] = useState([]);
   const [callStrategies, setCallStrategies] = useState([]);
   const [groups, setGroups] = useState([]);
   const [isResellerCompany, setIsResellerCompany] = useState(null);
   const [isOwnCompany, setIsOwnCompany] = useState(null);



   function getProfileApiUrl(){
      return API_COMPANY_PROFILE.replace(':id', id);
   }

      useEffect(() => {
         getUser();
      }, [])

useEffect(() => {
   const profileApiUrl = getProfileApiUrl();
   getApiCall(profileApiUrl, {})
   .then(resp => {
      setCompanyName(resp.name)
      setCompanyPhone(resp.phone)
      setCompanyAddress(resp.address)
      setCompanyPincode(resp.pincode)
      setIsOwnCompany(resp.is_own_company);
      setIsResellerCompany(resp.is_reseller_company);
      
      // Fix: Access the licence object correctly
      // const licence = resp?.subUserLicenceId || {};
      // const available = licence?.available_licence || {};
      // const total = licence?.total_licence || {};

            // setAvailableLicence(available);
            // setTotalLicence(total);

            // // Calculate used licence
            // const calculatedUsed = Object.fromEntries(
            //    Object.keys(total).map(key => [key, total[key] - (available[key] || 0)])
            // );

            // setUsedLicence(calculatedUsed);

            // // Set individual licence values
            // setCallCenterAdminTeamlead(available.role_ccadmin || 0);
            // setAgent(available.role_ccagent || 0);
            // setLiveAgent(available.live_agent || 0);
            // setChannel(available.channel || 0);
            // setAsReseller(available.reseller || 0);
            // setAsCompany(available.company || 0);

            const licence = resp?.subUserLicenceId || {};
            const available = licence?.available_licence || {};
            const total = licence?.total_licence || {};
            const used = licence?.used_licence || {};

            setAvailableLicence(available);
            setTotalLicence(total);

            // const calculatedUsed = Object.fromEntries(
            //   Object.keys(total).map(key => [key, total[key] - (available[key] || 0)])
            // );
            setUsedLicence(used);

            // current values (what user sees/edits)
            const currentValues = {
              role_ccadmin: available.role_ccadmin || 0,
              role_ccagent: available.role_ccagent || 0,
              live_agent: available.live_agent || 0,
              channel: available.channel || 0,
              reseller: available.reseller || 0,
              company: available.company || 0,
            };

            setCallCenterAdminTeamlead(currentValues.role_ccadmin);
            setAgent(currentValues.role_ccagent);
            setLiveAgent(currentValues.live_agent);
            setChannel(currentValues.channel);
            // setAsReseller(currentValues.reseller);
            setAsCompany(currentValues.company);

            // save initial values for comparison
            setInitialLicence(currentValues);

            const selectedGroups = resp.companyGroups.map(item => item.groups.group_id);

            const selectedLocations = resp.companyLocations.map(item => item.locations.location_id);

            const selectedStrategies = resp.companyCallStrategies.map(item => item.strategyMaster.id);


            setSelectedGroup(selectedGroups)
            setSelectedLocation(selectedLocations)
            setSelectedCallStrategy(selectedStrategies)
        }).catch(onError);
      }, [id]);

  useEffect(() => {
    const fetchMetaData = async () => {
      const user = JSON.parse(await AsyncStorage.getItem("user"));

      try {
        const [locationsData, groupsData, callStrategiesData] = await Promise.all([
          getApiCall(API_MANAGE_LOCATIONS_LIST, {}),
          getApiCall(API_MANAGE_GROUP_LISTING, {}),
          getApiCall(API_CALL_STRATEGIES_MASTER_LIST, {})
        ]);

        setCallStrategies(callStrategiesData?.map(strategy => ({
          value: strategy.id,
          label: strategy.name
        })) || []);

        if (user.role === USER_ROLES.SUPERADMIN) {
          // Normalize API data -> always { value, label }
          const normalizedLocations =
            (locationsData || []).map(loc => ({
              value: loc.location_id,
              label: loc.location_name,
            })) || [];

          const normalizedGroups =
            (groupsData || []).map(g => ({
              value: g.group_id,
              label: g.group_name,
            })) || [];

          setLocations(normalizedLocations);
          setGroups(normalizedGroups);
        } else {
          // Normalize user-based data -> always { value, label }
          const userGroups =
            groupsData.map(ug => ({
              value: ug.group_id,
              label: ug.group_name,
            })) || [];
          const userLocations =
            locationsData.map(ul => ({
              value: ul.location_id,
              label: ul.location_name,
            })) || [];

          setGroups(userGroups);
          setLocations(userLocations);
        }
      } catch (error) {
        console.error("Error fetching groups/locations:", error);
      }
    };

    fetchMetaData();
  }, []);


   // useEffect( () => {

   //    if(toastProps){
   //       setShowToast(true);
   //    }

   // }, [toastProps]);
const validateInput = (value, key) => {
  const num = Number(value);

  // NaN → treat as 0
  if (Number.isNaN(num)) return 0;

  // ❌ negative not allowed for anyone
  if (num < 0) {
    setErrors(prev => ({ ...prev, [key]: "Value cannot be negative" }));
    return num;
  }

  /* ================= SUPER ADMIN ================= */
  if (loginUserRole === USER_ROLES.SUPERADMIN) {

    // Only business rule that still applies
    if (key === "live_agent" && num > 10) {
      setErrors(prev => ({
        ...prev,
        [key]: "Live Agent cannot exceed 10",
      }));
      return num;
    }

    // ✅ NO upper limit checks
    setErrors(prev => ({ ...prev, [key]: "" }));
    return num;
  }

  /* ================= NON-SUPER ADMIN ================= */

  const licenceKeyMap = {
    role_ccadmin: "role_ccadmin",
    agent: "role_ccagent",
    live_agent: "live_agent",
    channel: "channel",
    reseller: "reseller",
    company: "company",
  };

  const licenceKey = licenceKeyMap[key];
  const initialValue = Number(initialLicence?.[licenceKey] || 0);
  const parentAvailable =
    parentLicence?.available_licence?.[licenceKey];

  // Allow keeping existing value
  if (num === initialValue) {
    setErrors(prev => ({ ...prev, [key]: "" }));
    return num;
  }

  // Parent availability check
const diff = num - initialValue;

if (
  parentAvailable !== undefined &&
  diff > parentAvailable &&
  diff > 0
) {
  setErrors(prev => ({
    ...prev,
    [key]: `You can increase only ${parentAvailable} more or Keep Existing value`,
  }));
  return num;
}


  // Live agent rule
  if (key === "live_agent" && num > 10) {
    setErrors(prev => ({
      ...prev,
      [key]: "Live Agent cannot exceed 10",
    }));
    return num;
  }

  setErrors(prev => ({ ...prev, [key]: "" }));
  return num;
};

async function getUser(){
  try {
   const user = JSON.parse(await AsyncStorage.getItem('user'));
   if (user) {
     setLoginUserRole(user.role);
   }
  } catch(err){
    console.log(err)
  }
}

   function validateCompanyFields() {
        let valid = true;
    
          if (!companyName.trim()) {
            valid = false;
            toast.error("Company name required");
          } else if (!validateCompanyPhone(companyPhone)) {
            valid = false;
            // setToastProps({
            //     message: "Company phone invalid format",
            //     type: "danger",
            toast.error("Company phone invalid format");
          } else if (!companyPincode.trim()) {
            valid = false;
            toast.error("Company pincode required");
          } else if (!/^\d{6}$/.test(companyPincode)) {
            valid = false;
            toast.error("Company pincode must be exactly 6 digits");
          } else if (!companyAddress.trim()) {
            valid = false;
            toast.error("Company address required");
          }
    
        return valid;
    }
async function submitForm(){
   setButtonDisable(true);

   if(!validateCompanyFields()){
      setButtonDisable(false);
      return;
   }

   // Check if there are any validation errors
   if (Object.values(errors).some(error => error !== "")) {
      toast.error("Please fix all validation errors before submitting");
      setButtonDisable(false);
      return;
   }

   // Only keep live agent validation
   if (liveAgent > 10) {
      toast.error("Live Agent cannot exceed 10");
      setButtonDisable(false);
      return;
   }

   const params = { 
      name: companyName,
      phone: companyPhone,
      address: companyAddress,
      pincode: companyPincode,
      is_reseller_company: isResellerCompany,
      is_own_company: isOwnCompany,
      licence: {
         role_ccadmin: callCenterAdminTeamlead,
         role_ccagent: agent,
         live_agent: liveAgent,
         channel,
         reseller: 0, // use asReseller when reseller box uncommented
         company: isOwnCompany ? 0 : asCompany,
      }
   }

        if (selectedGroup && selectedGroup.length > 0) {
          params.groups = Array.isArray(selectedGroup)
            ? selectedGroup.map(Number)
            : [Number(selectedGroup)];
        }

        if (selectedLocation && selectedLocation.length > 0) {
          params.locations = Array.isArray(selectedLocation)
            ? selectedLocation.map(Number)
            : [Number(selectedLocation)];
        }
        if (selectedCallStrategy && selectedCallStrategy.length > 0) {
          params.call_strategies = Array.isArray(selectedCallStrategy)
            ? selectedCallStrategy.map(Number)
            : [Number(selectedCallStrategy)];
        }

   const profileApiUrl = getProfileApiUrl();
   postApiCall(profileApiUrl, params)
   .then(onCompanyUpdateSuccess)
   .catch(onError);
}



   function onCompanyUpdateSuccess(resp){
      toast.success("Company updated successfully");
      setTimeout( () => {
         navigate(`/${ROUTES.COMPANIES.LIST}`);
      }, 1500);
   }

   function onError(err){
      setButtonDisable(false);
      toast.error(JSON.stringify(err));
   }

   useEffect(() => {
       getApiCall(API_PARENT_COMPANY_LICENCE).then((resp) => {
         setParentLicence(resp?.parentLicence);
       }).catch((error) => {
         toast.error(JSON.stringify(error));
       });
      }, []);

  function validateCompanyPhone(phone) {
    if (!phone) return false;
    return /^[0-9]{10}$/.test(phone.trim());
  }

   return(
      <>
        <div>
            <Row>
               <Col xl="12" lg="12">
                  <Card>
                     <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">Company Information</h4>
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <div className="new-user-info">
                           <form>
                              {
                                 <RenderUserCompanyFields
                                    isEditMode={true}
                                    company_name={companyName}
                                    company_phone={companyPhone}
                                    company_pincode={companyPincode}
                                    company_address={companyAddress}
                                    set_company_name={setCompanyName}
                                    set_company_phone={setCompanyPhone}
                                    set_company_pincode={setCompanyPincode}
                                    set_company_address={setCompanyAddress}
                                    isResellerCompany={isResellerCompany}
                                    isOwnCompany={isOwnCompany}
                                    // set_company_licence={setCompanyLicence}
                                    // company_licence={companyLicence}

                                 />
                              }
                              <div className="row">
                                <Form.Group className="col-md-6 form-group">
                                  <Form.Label>Call Strategy:</Form.Label>
                                  <Select
                                    options={callStrategies}
                                    value={callStrategies.filter(l => selectedCallStrategy.includes(l.value))}
                                    onChange={selected => setSelectedCallStrategy(selected.map(s => s.value))}
                                    isMulti
                                    placeholder="Select Call Strategy"
                                  />
                                </Form.Group>

                                <Form.Group className="col-md-6 form-group">
                                  <Form.Label>Location:</Form.Label>
                                  <Select
                                    options={locations}
                                    value={locations.filter(l => selectedLocation.includes(l.value))}
                                    onChange={selected => setSelectedLocation(selected.map(s => s.value))}
                                    isMulti
                                    placeholder="Select Location"
                                  />
                                </Form.Group>
                              </div>

                              <div className="row">
                                <Form.Group className="col-md-6 form-group">
                                  <Form.Label htmlFor="company_name"> Group:</Form.Label>
                                  <Select
                                    options={groups}
                                    value={groups.filter(g => selectedGroup.includes(g.value))}
                                    onChange={selected => setSelectedGroup(selected.map(s => s.value))}
                                    isMulti
                                    placeholder="Select Group"
                                  />
                                </Form.Group>
                                <Form.Group className="col-md-6 d-flex align-items-center gap-3">
                                  <Form.Label>Company Type:</Form.Label>
                                  {isResellerCompany &&
                                    <Form.Check
                                      type="checkbox"
                                      id="reseller_company"
                                      label="Reseller Company"
                                      checked={isResellerCompany}
                                      readOnly
                                    />
                                  }
                                  {isOwnCompany &&
                                  <Form.Check
                                    type="checkbox"
                                    id="own_company"
                                    label="Own Company"
                                    checked={isOwnCompany}
                                    readOnly
                                  />
                                  }
                                </Form.Group>
                              </div>
                              <hr/>
                              <div className="scroll-container" style={{ marginBottom: "30px"}}>
                                <h5 style={{ marginBottom: "10px" }}>Current Licence</h5>
                                <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                                  <thead>
                                    <tr>
                                      <th style={{ width: "15%" }}>Call Centers</th>
                                      <th style={{ width: "15%" }}>Total Agent</th>
                                      <th style={{ width: "15%" }}>Live Agent</th>
                                      <th style={{ width: "15%" }}>Channels</th>
                                      {/* {loginUserRole !== USER_ROLES.COMPANY_ADMIN &&
                                      <th style={{ width: "15%" }}>Reseller</th>} */}
                                      {!isOwnCompany &&
                                      <th style={{ width: "15%" }}>Company</th>}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control 
                                            type="number" 
                                            value={String(parseInt(String(callCenterAdminTeamlead), 10))}
                                            min={0}
                                            onChange={(e) => setCallCenterAdminTeamlead(validateInput(e.target.value, "role_ccadmin"))}
                                          />
                                          {errors.role_ccadmin && <small className="text-danger">{errors.role_ccadmin}</small>}
                                        </Form.Group>
                                      </td>

                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control 
                                            type="number" 
                                            value={String(parseInt(String(agent), 10))}
                                            min={0}
                                            onChange={(e) => setAgent(validateInput(e.target.value, "agent"))}
                                          />
                                          {errors.agent && <small className="text-danger">{errors.agent}</small>}
                                        </Form.Group>
                                      </td>

                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control 
                                            type="number" 
                                            value={String(parseInt(String(liveAgent), 10))}
                                            max={10}
                                            onChange={(e) => setLiveAgent(validateInput(e.target.value, "live_agent"))}
                                          />
                                          {errors.live_agent && <small className="text-danger">{errors.live_agent}</small>}
                                        </Form.Group>
                                      </td>

                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control 
                                            type="number" 
                                            value={String(parseInt(String(channel), 10))}
                                            min={0}
                                            onChange={(e) => setChannel(validateInput(e.target.value, "channel"))}
                                          />
                                          {errors.channel && <small className="text-danger">{errors.channel}</small>}
                                        </Form.Group>
                                      </td>

                                      {/* {loginUserRole !== USER_ROLES.COMPANY_ADMIN &&
                                      <td>
                                        <Form.Group className="form-group">
                                          <Form.Control 
                                            type="number" 
                                            value={String(parseInt(String(asReseller), 10))}
                                            min={0}
                                            onChange={(e) => setAsReseller(validateInput(e.target.value, "reseller"))}
                                          />
                                          {errors.reseller && <small className="text-danger">{errors.reseller}</small>}
                                        </Form.Group>
                                      </td>} */}

                                      {!isOwnCompany &&
                                              <td>
                                                <Form.Group className="form-group">
                                                  <Form.Control 
                                                    type="number" 
                                                    value={String(parseInt(String(asCompany), 10))}
                                                    min={0}
                                                    onChange={(e) => setAsCompany(validateInput(e.target.value, "company"))}
                                                  />
                                                  {errors.company && <small className="text-danger">{errors.company}</small>}
                                                </Form.Group>
                                              </td>}
                                            </tr>
                                          </tbody>
                                        </Table>
                                     </div>
                                      {/* // */}
                                      <div 
                                        style={{
                                          background: "#FFF8C6",
                                          color: "#8B5A2B",
                                          padding: "10px 15px",
                                          borderRadius: "6px",
                                          marginBottom: "15px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          marginTop:"70px",
                                          marginBottom:"20px"
                                        }}
                                      >
                                        <span><strong>Note:</strong> This licence detail is informational purpose and cannot be edited.</span>
                                      </div>


                                    <div className="scroll-container" style={{ marginBottom: "30px" }}>
                                      <h5 style={{ marginBottom: "10px" }}>Available Licence {loginUserRole === USER_ROLES.SUPERADMIN ? "" : "(Allocated Company)"}</h5>
                                      <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                                        <thead>
                                          <tr>
                                            <th>Call Centers</th>
                                            <th>Total Agent</th>
                                            <th>Live Agent</th>
                                            <th>Channels</th>
                                            {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                            <th>Reseller</th>} */}
                                            {!isOwnCompany &&
                                            <th>Company</th>}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {loginUserRole == USER_ROLES.SUPERADMIN ? <tr>
                                            <td>{availableLicence?.role_ccadmin || 0}</td>
                                            <td>{availableLicence?.role_ccagent || 0}</td>
                                            <td>{availableLicence?.live_agent || 0}</td>
                                            <td>{availableLicence?.channel || 0}</td>
                                            {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                            <td>{availableLicence?.reseller || 0}</td> } */}
                                            {!isOwnCompany &&
                                            <td>{availableLicence?.company || 0}</td>}
                                          </tr> : <tr>
                                            <td>{parentLicence?.available_licence?.role_ccadmin || 0}</td>
                                            <td>{parentLicence?.available_licence?.role_ccagent || 0}</td>
                                            <td>{parentLicence?.available_licence?.live_agent || 0}</td>
                                            <td>{parentLicence?.available_licence?.channel || 0}</td>
                                            {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                            <td>{parentLicence?.available_licence?.reseller || 0}</td> } */}
                                            {!isOwnCompany &&
                                            <td>{parentLicence?.available_licence?.company || 0}</td>}
                                          </tr>}
                                        </tbody>
                                      </Table>
                                    </div>
                                    {/* // */}
                                    <div className="scroll-container" style={{ marginBottom: "30px" }}>
                                      <h5 style={{ marginBottom: "10px" }}>Used Licence (Current Company)</h5>
                                      <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                                        <thead>
                                          <tr>
                                            <th>Call Centers</th>
                                            <th>Total Agent</th>
                                            <th>Live Agent</th>
                                            <th>Channels</th>
                                            {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                            <th>Reseller</th> } */}
                                            {!isOwnCompany &&
                                            <th>Company</th>}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>{usedLicence?.role_ccadmin || 0}</td>
                                            <td>{usedLicence?.role_ccagent || 0}</td>
                                            <td>{usedLicence?.live_agent || 0}</td>
                                            <td>{usedLicence?.channel || 0}</td>
                                            {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                            <td>{usedLicence?.reseller || 0}</td>} */}
                                            {!isOwnCompany &&
                                            <td>{usedLicence?.company || 0}</td>}
                                          </tr>
                                        </tbody>
                                      </Table>
                                    </div>


                              <Button 
                                onClick={submitForm} 
                                type="button" 
                                variant="btn btn-primary" 
                                disabled={buttonDisable || Object.values(errors).some(error => error !== "")}
                              >
                                Update Company &nbsp;
                                {
                                  buttonDisable ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></>
                                }
                              </Button>

                           </form>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

      </>
  )

}

export default CompanyUpdate;